import React from 'react';
import { Translate } from 'react-redux-i18n';
import { history } from '../../routers/AppRouter';

const TableRegisterButton = (props) => {
  const { route } = props;
  return (
    <button
      onClick={() => history.push(route)}
      type="button"
      className="btn btn-dark"
    >
      <Translate value="register" />
    </button>
  );
};
export default TableRegisterButton;
